import { gql, TypedDocumentNode } from '@apollo/client';
import type { Customer } from '../models/Customer';
import { ProductHistoricalBulkPricingMarkupLineItem } from '../models/ProductBulkPricingMarkupLineItem';

export const GET_CUSTOMERS_QUERY: TypedDocumentNode<{ customers: Customer[] }> = gql`
  query GetCustomers {
    customers(order: { name: ASC }) {
      id,
      name,
      address,
      city,
      state,
      zip,
      contactId,
      contact {
        id,
        name,
        email,
        phone
      }
    }
  }
`;

export const GET_CUSTOMER_BY_ID_QUERY: TypedDocumentNode<{ customer: Customer }, { id: number }> = gql`
  query GetCustomerById($id: Int!) {
    customer: customerById(id: $id) {
      id,
      name,
      address,
      city,
      state,
      zip,
      contactId,
      contact {
        id,
        name,
        email,
        phone
      },
      products(order: { name: ASC }) {
        id,
        name,
        productInventoryItems {
          packagingType,
          quantityOnHand,
          batchId,
          batch {
            lotNumber
          }
        }
      },
      bulkPricingProducts(order: { name: ASC }) {
        id,
        name,
        totalAverageItemCostPerBatchPound,
        bulkPricingMarkupLineItems(order: { pounds: ASC }) {
          id,
          pounds,
          markup
        },
        historicalBulkPricingMarkupLineItems(order: { pounds: ASC }) {
          id,
          pounds,
          markup
        }
      }
    }
  }
`;

export const GET_PRODUCT_HISTORICAL_BULK_PRICING_MARKUP_LINE_ITEMS_BY_CUSTOMER_ID_QUERY: TypedDocumentNode<{ historicalBulkPricingMarkupLineItemsByProduct: [{ key: number, value: [{ key: string, value: ProductHistoricalBulkPricingMarkupLineItem[] }] }] }, { id: number }> = gql`
  query GetProductHistoricalBulkPricingMarkupLineItemsByCustomerId($id: Int!) {
    historicalBulkPricingMarkupLineItemsByProduct: productHistoricalBulkPricingMarkupLineItemsByCustomerId(id: $id) {
      key,
      value {
        key,
        value {
          id,
          pounds,
          markup
        }
      }
    }
  }
`;
